class ApplePayPaymentHelper {
    constructor() {
        this.enabled = false;
        this.appleMerchantIdentifier = null;
        this.merchantDisplayName = null;
        this.countryCode = 'GB';
        this.currencyCode = 'GBP';
        this.pendingTransactionId = null;
        this.paymentIsLocked = false;
        this.initialiseUrl = null;
        this.validateSessionUrl = null;
        this.requestPaymentUrl = null;
    }
    onApplePayLoaded() {
        if (this.enabled && window.ApplePaySession) {
            this.onIsReadyToPayResult(window.ApplePaySession.canMakePayments());

            //alternate more reliable approach, BUT requires Apple Pay as primary default
            //var promise = ApplePaySession.canMakePaymentsWithActiveCard(this.appleMerchantIdentifier);
            //promise.then(function (canMakePayments) {
            //    this.onIsReadyToPayResult(canMakePayments);
            //});
        }
    }
    onApplePayButtonClicked() {
        try
        {
            if (!this.enabled) return;
            if (this.paymentIsLocked) { return; }
            if (!window.ApplePaySession) { return; }

            const productData = this.onProductDataRequested();
            if (!productData) {
                this.onError("Product data missing", "ApplePayPaymentHelper/onApplePayButtonClicked", false, true);
                return;
            }

            this.paymentIsLocked = true;
            this.pendingTransactionId = null;
            this.onPaymentExecuting();

            if (this.initialiseUrl) { //this call is optional - records intent
                let helperInstance = this;
                $.ajax({
                    data: JSON.stringify({
                        productId: productData.productId,
                        offerId: productData.offerId,
                        transactionAmount: productData.amountToPay
                    }),
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: helperInstance.initialiseUrl,
                    dataType: "json",
                    timeout: 60000,
                    success: function (response, textStatus, jqXHR) {
                        if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                            fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                        }
                        var transactionId = null;
                        var responseData = response;
                        if (response && response.d) responseData = response.d;

                        if (responseData) {
                            transactionId = responseData.TransactionId;
                        }

                        if (transactionId != null) {
                            helperInstance.pendingTransactionId = transactionId;
                        }
                        else {
                            //as session will begin anyway work without a pending transactionId
                            //helperInstance.paymentIsLocked = false;
                            //helperInstance.onError(helperInstance.initialiseUrl + ' call failed.', helperInstance.initialiseUrl, true);
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        //as session will begin anyway work without a pending transactionId
                        //helperInstance.paymentIsLocked = false;
                        //helperInstance.onError(errorThrown, helperInstance.initialiseUrl, true);
                        if (typeof (fourdHandleAjaxError) != 'undefined') {
                            fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                        }
                    }
                });
            }

            //Call in gesture handler - not allowed from ajax callback
            this.beginApplePaySession(productData);

        }
        catch (err)
        {
            this.paymentIsLocked = false;
            this.onError(err, 'ApplePayPaymentHelper/onApplePayButtonClicked', true);
        }
    }
    beginApplePaySession(productData) {
        try {
            // Define ApplePayPaymentRequest
            const request = Object.assign(
                {},
                //fixed fields
                {
                    "merchantCapabilities": [
                        "supports3DS"
                    ],
                    "supportedNetworks": [
                        "visa",
                        "masterCard"
                    ],
                    "requiredBillingContactFields": [
                        "postalAddress",
                        "name",
                        "email"
                    ],
                    "requiredShippingContactFields": [
                        "email"
                    ]
                },
                //dynamic fields
                {
                    "countryCode": this.countryCode,
                    "currencyCode": this.currencyCode,
                    "total": {
                        "label": this.merchantDisplayName,
                        "type": "final",
                        "amount": parseFloat(productData.amountToPay).toFixed(2) //doesnt like 4 trailing zeros
                    }
                }
            );

            let helperInstance = this;
            // Create ApplePaySession
            const session = new ApplePaySession(3, request); //IOS11 onwards

            session.onvalidatemerchant = function (event) {
                // Call your own server to request a new merchant session.
                helperInstance.onValidateMerchant(session, event);
            };

            //session.onpaymentmethodselected = function (event) {
            //    // Define ApplePayPaymentMethodUpdate based on the selected payment method.
            //    // No updates or errors are needed, pass an empty object.
            //    const update = {};
            //    session.completePaymentMethodSelection(update);
            //};

            //session.onshippingmethodselected = function (event) {
            //    // Define ApplePayShippingMethodUpdate based on the selected shipping method.
            //    // No updates or errors are needed, pass an empty object. 
            //    const update = {};
            //    session.completeShippingMethodSelection(update);
            //};

            //session.onshippingcontactselected = function (event) {
            //    // Define ApplePayShippingContactUpdate based on the selected shipping contact.
            //    const update = {};
            //    session.completeShippingContactSelection(update);
            //};

            session.onpaymentauthorized = function (event) {
                // Define ApplePayPaymentAuthorizationResult
                helperInstance.onPaymentAuthorised(session, event);
            };

            session.oncancel = function (event) {
                helperInstance.paymentIsLocked = false;
                helperInstance.pendingTransactionId = null;
                helperInstance.onPaymentCancelled(event);
            };

            session.begin();
        }
        catch (err)
        {
            this.paymentIsLocked = false;
            this.onError(err, 'ApplePayPaymentHelper/beginApplePaySession', true);
        }

    }
    abortApplePaySession(session) {
        let wasPaymentExecuting = this.paymentIsLocked;
        try {
            if (this.paymentIsLocked) {
                // Mark as not locked
                this.paymentIsLocked = false;
                // Attempt to abort the ApplePaySession
                session?.abort();
            } else {
                // Already marked as not locked so has already been cancelled or failed
                // Should we attempt an abort anyway?
                session?.abort();
            }
        }
        catch (err) {
            this.onError(err, 'ApplePayPaymentHelper/abortApplePaySession', wasPaymentExecuting);
        }
    }
    onValidateMerchant(session, event) {
        var validationUrl = event.validationURL; //not really necessary as it is a static url, but still supported
        let helperInstance = this;

        $.ajax({
            data: JSON.stringify({
                transactionId: helperInstance.pendingTransactionId,
                validationUrl: validationUrl,
                appleMerchantIdentifier: helperInstance.appleMerchantIdentifier,
                merchantDisplayName: helperInstance.merchantDisplayName
            }),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: helperInstance.validateSessionUrl,
            dataType: "json",
            timeout: 60000,
            success: function (response, textStatus, jqXHR) {
                if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                    fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                }
                try {
                    var validationReponseContentString = null;
                    var responseData = response;
                    if (response && response.d) responseData = response.d;

                    if (responseData) {
                        validationReponseContentString = responseData.ValidationReponseContent;
                    }

                    if (validationReponseContentString != null) {
                        var merchantSession = JSON.parse(validationReponseContentString);
                        session.completeMerchantValidation(merchantSession);
                    }
                    else {
                        helperInstance.abortApplePaySession(session);
                        helperInstance.onError(helperInstance.validateSessionUrl + ' call failed.', helperInstance.validateSessionUrl, true);
                    }
                }
                catch (err) {
                    helperInstance.abortApplePaySession(session);
                    helperInstance.onError(err, 'ApplePayPaymentHelper/completeMerchantValidation', true);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                helperInstance.abortApplePaySession(session);
                helperInstance.onError(errorThrown, helperInstance.validateSessionUrl, true);

                if (typeof (fourdHandleAjaxError) != 'undefined') {
                    fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                }
            }
        });

    }
    onPaymentAuthorised(session, event) {

        try {
            //this.onPaymentExecuting();
            this.paymentIsLocked = false; //we have blocking UI overlay confirmed 
            // @todo pass payment token to your gateway to process payment
            var paymentTokenString = JSON.stringify(event.payment.token.paymentData);
            var billingContact = event.payment.billingContact; //or event.payment.token.paymentMethod.billingContact ???
            var shippingContact = event.payment.shippingContact;
            var paymentMethod = event.payment.token.paymentMethod;

            var cardData = {};
            if (billingContact) {
                if (billingContact.emailAddress) cardData.BillEmail = billingContact.emailAddress;

                cardData.BillFirstName = billingContact.givenName;
                cardData.BillLastName = billingContact.familyName;

                if (billingContact.addressLines && billingContact.addressLines.length > 0) cardData.BillStreet1 = billingContact.addressLines[0];
                if (billingContact.addressLines && billingContact.addressLines.length > 1) cardData.BillStreet2 = billingContact.addressLines[1];
                cardData.BillCity = billingContact.locality ;
                cardData.BillState = billingContact.administrativeArea ;
                cardData.BillCountry = billingContact.countryCode; //there is also billingContact.country
                //cardData.BillCountryAlpha3Code = billingContact.countryCode ;
                cardData.BillPostalCode = billingContact.postalCode ;

            }
            if (!cardData.BillEmail && shippingContact) {
                if (shippingContact.emailAddress) cardData.BillEmail = shippingContact.emailAddress;
            }
            //TODO there's also a billingContact on paymentMethod - are they the same?
            if (paymentMethod) {

                cardData.CardAccountNumber = null; //paymentMethod.displayName may contain last 4 digits but not documented e.g. 'Visa 7008'
                if (paymentMethod.network) {
                    var networkString = paymentMethod.network.toUpperCase();
                    if (networkString === 'VISA') {
                        cardData.CardTypeId = 1;
                    }
                    else if (networkString === 'MASTERCARD') {
                        cardData.CardTypeId = 2;
                    }
                }

            }

            var productData = this.onProductDataRequested();
            let helperInstance = this;

            $.ajax({
                data: JSON.stringify({
                    productId: productData.productId,
                    offerId: productData.offerId,
                    transactionAmount: productData.amountToPay,
                    encryptedPaymentData: window.btoa(paymentTokenString),
                    cardData: cardData,
                    appleResponseData: JSON.stringify(event.payment),
                    transactionId: helperInstance.pendingTransactionId
                }),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: helperInstance.requestPaymentUrl,
                dataType: "json",
                timeout: 60000,
                success: function (response, textStatus, jqXHR) {
                    if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                        fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                    }
                    try {
                        var isAccepted = false;
                        //no longer pending - subsequent attempts should create a new transaction - e.g. trying different card
                        helperInstance.pendingTransactionId = null;
                        var responseData = response;
                        if (response && response.d) responseData = response.d;

                        if (responseData) {
                            isAccepted = responseData.TransactionAccepted;
                        }
                        if (isAccepted) {
                            var result = {
                                "status": ApplePaySession.STATUS_SUCCESS
                            };
                            session.completePayment(result);
                        }
                        else {
                            //documentation states that payment sheet is dismissed for failure
                            var result = {
                                "status": ApplePaySession.STATUS_FAILURE
                            };
                            session.completePayment(result);
                            //session.abort(); //close ApplePay
                        }

                        helperInstance.onPaymentExecuted(isAccepted, responseData);
                    }
                    catch (err) {
                        //if session.completePayment wasn't called - payment sheet will clear after 30 sec
                        helperInstance.onError(err, 'ApplePayPaymentHelper/completePayment', true);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    //complete session early - otherwise there's a 30 sec timeout
                    var result = {
                        "status": ApplePaySession.STATUS_FAILURE
                    };
                    session.completePayment(result);

                    helperInstance.onError(errorThrown, helperInstance.requestPaymentUrl, true);

                    if (typeof (fourdHandleAjaxError) != 'undefined') {
                        fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                    }
                }
            });

        }
        catch (err) {
            //complete session early - otherwise there's a 30 sec timeout
            var result = {
                "status": ApplePaySession.STATUS_FAILURE
            };
            session.completePayment(result);

            this.onError(err, 'ApplePayPaymentHelper/processPayment', true);
        }

    }
    initialise(options) {
        var result = false;

        try {
            if (!options) options = {};
            if (!options.config) options.config = {};
            if (!options.callbacks) options.callbacks = {};
            if (typeof (FourDConfiguration) !== 'undefined' && FourDConfiguration.endpoints) {
                if (!options.config.initialiseUrl && typeof (FourDConfiguration.endpoints.applePayInitialisePayment) == 'string') options.config.initialiseUrl = FourDConfiguration.endpoints.applePayInitialisePayment;
                if (!options.config.validateSessionUrl && typeof (FourDConfiguration.endpoints.applePayValidateSession) == 'string') options.config.validateSessionUrl = FourDConfiguration.endpoints.applePayValidateSession;
                if (!options.config.requestPaymentUrl && typeof (FourDConfiguration.endpoints.applePayRequestPayment) == 'string') options.config.requestPaymentUrl = FourDConfiguration.endpoints.applePayRequestPayment;

            }

            if (options.config
                && options.config.merchantDisplayName
                && options.config.validateSessionUrl
                && options.config.requestPaymentUrl) {
                this.appleMerchantIdentifier = options.config.appleMerchantIdentifier;
                this.merchantDisplayName = options.config.merchantDisplayName;
                this.validateSessionUrl = options.config.validateSessionUrl;
                this.requestPaymentUrl = options.config.requestPaymentUrl;
                if (options.config.initialiseUrl) this.initialiseUrl = options.config.initialiseUrl;
                if (options.config.countryCode) this.countryCode = options.config.countryCode;
                if (options.config.currencyCode) this.currencyCode = options.config.currencyCode;

                if (options.callbacks
                    && options.callbacks.onProductDataRequested
                ) {
                    if (typeof (options.callbacks.onProductDataRequested) == 'function') this.onProductDataRequested = options.callbacks.onProductDataRequested;
                    if (typeof (options.callbacks.onIsReadyToPayResult) == 'function') this.onIsReadyToPayResult = options.callbacks.onIsReadyToPayResult;
                    if (typeof (options.callbacks.onError) == 'function') this.onError = options.callbacks.onError;
                    if (typeof (options.callbacks.onPaymentExecuting) == 'function') this.onPaymentExecuting = options.callbacks.onPaymentExecuting;
                    if (typeof (options.callbacks.onPaymentCancelled) == 'function') this.onPaymentCancelled = options.callbacks.onPaymentCancelled;
                    if (typeof (options.callbacks.onPaymentExecuted) == 'function') this.onPaymentExecuted = options.callbacks.onPaymentExecuted;

                    result = true;
                    this.enabled = true;

                    this.onApplePayLoaded();
                }
            }
        }
        catch (err) {
            this.onError(err, 'ApplePayPaymentHelper/initialise');
        }
        return result;

    }
    onProductDataRequested() { return null; }
    onIsReadyToPayResult(isAccepted) { }
    onError(err, stageText, wasPaymentExecuting, wasProductMissing) { }
    onPaymentExecuting() { }
    onPaymentCancelled(event) { }
    onPaymentExecuted(isAccepted, responseData) { }
};

const ApplePayPayment = new ApplePayPaymentHelper();